/** Normalize any error thrown by axios into a readable string. */
export function errorMessage(err, fallback = "Une erreur est survenue") {
  const detail = err?.response?.data?.detail;
  if (Array.isArray(detail)) {
    return detail.map((d) => d?.msg || String(d)).filter(Boolean).join(", ") || fallback;
  }
  if (typeof detail === "string") return detail;
  if (err?.message) return err.message;
  return fallback;
}
